<template>
    <img :src="img" style="border-radius: 10px;">
</template>

<script>
    import chm from "@/assets/images/file/file_chm.png"
    import code from "@/assets/images/file/file_code.png"
    import css from "@/assets/images/file/file_css.png"
    import csv from "@/assets/images/file/file_csv.png"
    import excel from "@/assets/images/file/file_excel.png"
    import install from "@/assets/images/file/file_install.png"
    import music from "@/assets/images/file/file_music.png"
    import onenote from "@/assets/images/file/file_onenote.png"
    import pdf from "@/assets/images/file/file_pdf.png"
    import pic from "@/assets/images/file/file_pic.png"
    import ppt from "@/assets/images/file/file_ppt.png"
    import rarzip from "@/assets/images/file/file_rarzip.png"
    import txt from "@/assets/images/file/file_txt.png"
    import unknow from "@/assets/images/file/file_unknow.png"
    import video from "@/assets/images/file/file_video.png"
    import word from "@/assets/images/file/file_word.png"

    export default {
        name: "file-ext",
        props: {
            icon: {
                type: String,
                default: 'unknow'
            }
        },
        data() {
            return {
                img: unknow
            }
        },
        methods: {
            fileMap: function (fileExt) {
                const map = {
                    chm,
                    php: code,
                    py: code,
                    java: code,
                    mysql: code,
                    sql: code,
                    html: code,
                    css,
                    csv,
                    xls: excel,
                    xlsx: excel,
                    exe: install,
                    apk: install,
                    ipa: install,
                    bin: install,
                    mp3: music,
                    wma: music,
                    one: onenote,
                    pdf,
                    jpg: pic,
                    jpeg: pic,
                    png: pic,
                    bmp: pic,
                    ps: pic,
                    ppt,
                    pptx: ppt,
                    rar: rarzip,
                    zip: rarzip,
                    gzip: rarzip,
                    tar: rarzip,
                    '7z': rarzip,
                    txt,
                    unknow,
                    mp4: video,
                    flv: video,
                    rmvb: video,
                    wmv: video,
                    doc: word,
                    docx: word,
                    wps: word,
                };
                let img = map[fileExt];
                if (!img) {
                    return unknow;
                } else {
                    return img;
                }
            }
        },
        created: function () {
            this.img = this.fileMap(this.icon);
        },
        watch:{
            icon:function () {
                this.img = this.fileMap(this.icon);
            }
        },
    }
</script>

<style scoped lang="less">
    .ext-icon{
        border-radius: 5px;
    }
</style>